import React, { Component } from "react";
import PropTypes from "prop-types";
import { CardActions, Typography, Button } from "material-ui";
import PostHeader from "./PostHeader";
import CorrectionTextEdit from "./CorrectionTextEdit";
import ReactionButton from "./ReactionButton";
import PostEditor from "./PostEditor";
import { withStylesAndTranslation } from "../utils/container";

const styleSheet = theme => ({
    content: {
        padding: `0 ${theme.spacing.unit * 3}px`,
        "& last-child": {
            padding: `0 ${theme.spacing.unit * 3}px`
        }
    },
    reactionButtonContainer: {
        marginLeft: theme.spacing.unit * -2
    }
});

class Correction extends Component {
    onGotoPost = () => {
        this.props.onGotoPost(this.props.correction);
    };

    renderCardActions() {
        const { edit, showGoToPost, correction, classes, t } = this.props;
        if (edit) {
            return;
        }
        let goToPostButton;
        if (showGoToPost) {
            goToPostButton = (
                <Button dense={true} onClick={this.onGotoPost}>
                    {t("correction.View post")}
                </Button>
            );
        }

        const { currentUserId, onReactionButtonClick } = this.props;

        const numReactions = correction.reactions.count();
        const active = !!correction.reactions.find(
            r => r.userId === currentUserId
        );

        return (
            <CardActions>
                <div className={classes.reactionButtonContainer}>
                    <ReactionButton
                        active={active}
                        useIconButton={true}
                        numReactions={numReactions}
                        onReactionButtonClick={() =>
                            onReactionButtonClick({
                                correction,
                                active,
                                userId: currentUserId
                            })}
                    />
                </div>
                {goToPostButton}
            </CardActions>
        );
    }

    componentDidMount() {
        if (this.props.autoFocus) {
            this.focus();
        }
    }

    focus() {
        if (this.textEdit) {
            this.textEdit.focus();
        }
    }

    onMenuItemClick = action => {
        const { correction, onMenuItemClick } = this.props;
        onMenuItemClick({ action, correction });
    };

    getHeaderMenuItemConfig() {
        const { correction, currentUserId } = this.props;
        const copyLinkToShare = {
            text: "correction.Copy link to share",
            action: "copyLink"
        };
        if (currentUserId === correction.author.id) {
            return [
                copyLinkToShare,
                {
                    text: "correction.Edit",
                    action: "edit"
                },
                {
                    text: "correction.Delete",
                    action: "delete"
                }
            ];
        }
        return [
            copyLinkToShare,
            {
                text: "correction.Report abuse",
                action: "report"
            }
        ];
    }

    render() {
        const { correction, edit, classes } = this.props;
        const { author, body, edits, comment } = correction;

        let correctionContent, commentContent;
        if (body) {
            correctionContent = (
                <Typography type="body1" component="div">
                    <CorrectionTextEdit
                        ref={c => {
                            this.textEdit = c;
                        }}
                        body={body}
                        edits={edits}
                        readOnly={!edit}
                    />
                </Typography>
            );
        }
        if (comment) {
            commentContent = <PostEditor readOnly={true} text={comment} />;
        }
        return (
            <div ref={this.props.rootRef}>
                <PostHeader
                    postId={correction.postId}
                    correctionId={correction.id}
                    onMenuItemClick={this.onMenuItemClick}
                    user={author}
                    date={correction.creationDate}
                    menuItemConfig={this.getHeaderMenuItemConfig()}
                />
                <div className={classes.content}>
                    {correctionContent}
                    {commentContent}
                    {this.renderCardActions()}
                </div>
            </div>
        );
    }
}

Correction.propTypes = {
    autoFocus: PropTypes.bool,
    edit: PropTypes.bool,
    correction: PropTypes.object,
    classes: PropTypes.object,
    showGoToPost: PropTypes.bool,
    onGotoPost: PropTypes.func,
    currentUserId: PropTypes.string,
    onReactionButtonClick: PropTypes.func,
    onMenuItemClick: PropTypes.func,
    rootRef: PropTypes.func,
    t: PropTypes.func.isRequired
};

Correction.defaultProps = {
    edit: false,
    autoFocus: false,
    showGoToPost: false,
    onGoToPost: () => {},
    onReactionButtonClick: () => {},
    onMenuItemClick: () => {},
    rootRef: () => {}
};

export default withStylesAndTranslation(Correction, styleSheet);



// WEBPACK FOOTER //
// ./src/components/Correction.jsx